module.exports = __webpack_public_path__ + "img/icon-stockpicker-calculating@3x.5231f504.png";